module.exports = __webpack_public_path__ + "static/img/2306_phase_function_Paper_PointsHejduk_Prediction.b43f750.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2306_phase_function_Paper_PointsHejduk_Prediction.png
// module id = EHke
// module chunks = 0